/*!
 * This component may not be reversed engineered for hacking or abuse
 * of The EGT Universe, The Universe, or third-party apps.
 * 
 * Written for:
 * Stallion.
 * Prompt.
 * Universe App Scafolding Object
 * 
 * Justin K Kazmierczak
 * 
 * Quick function for resolve file paths to app context.
 * 
 */

// var _nProcess = null;
// if (typeof process !== "undefined") {
//     _nProcess = process;
// }

var namespace = "isServer";

// console.log("Resolving path", p);
var path = require("path");

var santize = require("../sanitize.js");

/**
 * Resloves a path based on the APP as the home directory. Uses path.join on additional arguments.
 * @! => process.cwd()
 * 
 * @!/functions will equal /myapp path.join with "./functions"
 * /myapp/functions
 * @param {*} path The path to resolve.
 * @returns an adjusted path
 */
function isServer() {

    //does process exsist?
    if (typeof process === "undefined") {
        return false;
    } else {
        //is it node?
        if (process.versions && process.versions.node) {
            return true;
        } else {
            return false;
        }
    }

}

module.exports = {
    namespace: namespace,
    // mamespace: universe.functions.resolve,
    function: isServer,
    tests: [{
        namespace: `${namespace}.default`,
        must: true,
        run: async () => {
           
            //test resolve

            return isServer();

        }
    }]
};